import React from 'react';

import { RenderConfigurableSidebarLink } from '@uikit/old/ConfigurableSidebar/_components/ConfigurableSidebarLinks';
import urls from '@constants/urls';

type SidebarItemRenderPropsType = {
  pathname: string;
};

export default [
  {
    pageKey: 'profile',
    RenderLink: ({ pathname }: SidebarItemRenderPropsType): JSX.Element => {
      return (
        <RenderConfigurableSidebarLink
          title="Profile"
          icon="profile"
          url={urls.PROFILE}
          isActive={pathname === urls.PROFILE}
        />
      );
    },
  },
  {
    pageKey: 'billing',
    RenderLink: ({ pathname }: SidebarItemRenderPropsType): JSX.Element => {
      return (
        <RenderConfigurableSidebarLink
          title="Billing"
          icon="billing"
          url={urls.SETTINGS_BILLING}
          isActive={pathname === urls.SETTINGS_BILLING}
        />
      );
    },
  },
  {
    pageKey: 'workspaces',
    RenderLink: ({ pathname }: SidebarItemRenderPropsType): JSX.Element => {
      return (
        <RenderConfigurableSidebarLink
          title="Workspaces"
          icon="workspace"
          url={urls.SETTINGS_WORKSPACE}
          isActive={pathname === urls.SETTINGS_WORKSPACE}
        />
      );
    },
  },
  {
    pageKey: 'allMembers',
    RenderLink: ({ pathname }: SidebarItemRenderPropsType): JSX.Element => {
      return (
        <RenderConfigurableSidebarLink
          title="Team members"
          icon="member"
          url={urls.ALL_MEMBERS}
          isActive={pathname === urls.ALL_MEMBERS}
        />
      );
    },
  },
];
